import React, {Component} from 'react';
import {Link} from 'react-router';
import Loading from './LoadingComponent';
import Navigator from './NavigatorComponent';
import OpportunityActions from 'actions/OpportunityActions';
import OpportunityStore from 'stores/OpportunityStore';

require('styles/OpportunityMemeber.scss');
class OpportunityMembersComponent extends Component{
  constructor(props) {
    super(props);
    let opportunityStore = OpportunityStore.getState();
    let {id,tab,active} = this.props;
    this.state = {
      id: id,
      registers: opportunityStore.registers,
      selecters: opportunityStore.selecters,
      registersLoading: opportunityStore.registersLoading,
      registersHasMore: opportunityStore.registersHasMore,
      selectersLoading: opportunityStore.selectersLoading,
      selectersHasMore: opportunityStore.selectersHasMore,
      hasConfirmed: opportunityStore.opportunity.hasConfirmed,
      active: active,
      tab: tab,
      showNavigator: false
    };
    this.onOpportunityChange = this.onOpportunityChange.bind(this);
    this.onOpportunityScroll = this.onOpportunityScroll.bind(this);
  }
  componentDidMount(){
    OpportunityStore.listen(this.onOpportunityChange);
    if(this.state.tab === 'register'){
      OpportunityActions.clearOpportunityRegister();
      OpportunityActions.fetchOpportunityRegister(this.state.id);
    }else if (this.state.tab === 'selecter'){
      OpportunityActions.clearOpportunitySelecter();
      OpportunityActions.fetchOpportunitySelecter(this.state.id);
    }
    window.addEventListener('scroll',this.onOpportunityScroll);
  }
  componentWillUnmount(){
    OpportunityStore.unlisten(this.onOpportunityChange);
    window.removeEventListener('scroll',this.onOpportunityScroll);
  }
  componentWillReceiveProps(nextProps) {
		let {id,tab,active} = nextProps;
    if(tab !== this.state.tab){
      this.setState({id: id,tab: tab, active:active});
      if(tab === 'register'){
        OpportunityActions.setRegistersLoading(true);
        OpportunityActions.clearOpportunityRegister();
        OpportunityActions.fetchOpportunityRegister(this.state.id);
      }else if (tab === 'selecter'){
        OpportunityActions.setSelectersLoading(true);
        OpportunityActions.clearOpportunitySelecter();
        OpportunityActions.fetchOpportunitySelecter(this.state.id);
      }
    }else{
      this.setState({id: id,tab: tab, active:active});
    }
	}
  onOpportunityChange(store){
    this.setState({
      hasConfirmed: store.opportunity.hasConfirmed,
      registers: store.registers,
      selecters: store.selecters,
      registersLoading: store.registersLoading,
      registersHasMore: store.registersHasMore,
      selectersLoading: store.selectersLoading,
      selectersHasMore: store.selectersHasMore
    });
  }
  onOpportunityScroll(event) {
    if(this.state.fetchTimeOut) {
      clearTimeout(this.state.fetchTimeOut);
    }
    let scrollTop = $(document).scrollTop();
    let clientHeight = event.srcElement.body.clientHeight;
    let scrollHeight = event.srcElement.body.scrollHeight;
    if(scrollTop + clientHeight === scrollHeight) {
      let opportunity_id = this.state.id;
      if(this.state.tab === 'register'){
        OpportunityActions.setRegistersLoading(true);
        this.setState({fetchTimeOut: setTimeout(OpportunityActions.fetchOpportunityRegister.bind(null,opportunity_id), 1000)});
      } else if (this.state.tab === 'selecter'){
        OpportunityActions.setSelectersLoading(true);
        this.setState({fetchTimeOut: setTimeout(OpportunityActions.fetchOpportunitySelecter.bind(null,opportunity_id), 1000)});
      }
    }
    if(scrollTop > 500){
      this.setState({showNavigator:true});
    }else{
      this.setState({showNavigator:false});
    }
  }
  loadMore() {
    let opportunity_id = this.state.id;
    if(this.state.tab === 'register'){
      OpportunityActions.setRegistersLoading(true);
      OpportunityActions.fetchOpportunityRegister(opportunity_id)
    } else if (this.state.tab === 'selecter'){
      OpportunityActions.setSelectersLoading(true);
      OpportunityActions.fetchOpportunitySelecter(opportunity_id)
    } 
  }
  render(){
    let users,loading,hasMore,notification,navigator;
    if(this.state.tab === 'register'){
      users = this.state.registers;
      loading = this.state.registersLoading;
      hasMore = this.state.registersHasMore;
    } else if(this.state.tab === 'selecter'){
      users = this.state.selecters;
      loading = this.state.selectersLoading;
      hasMore = this.state.selectersHasMore;
    }
    if(this.state.showNavigator){
      navigator = <Navigator action='top' number={4} />;
    }
    if(this.state.hasConfirmed){
      if(!loading){
        if(this.state.tab === 'selecter' && !this.state.selecters.length){
          notification = <div className='notification'>此机会已流拍</div>
        }
        if(this.state.tab === 'register' && !this.state.registers.length){
          notification = (<div className='notification'>活动已结束，
            <a href="javascript:void(0)" onClick={this.props.selectSelecter}>查看</a>获选名单
          </div>)
        }
      }else{
        if(this.state.tab === 'selecter' && !this.state.selecters.length){
          notification = <div className='notification'>加载中...</div>
        }
        if(this.state.tab === 'register' && !this.state.registers.length){
          notification = <div className='notification'>加载中...</div>
        }
      }
    }else{
      let tip = '活动还未结束，快去报名吧!'
      if(this.state.tab === 'selecter' && !this.state.selecters.length){
        notification = <div className='notification'>{tip}</div>
      }
      if(this.state.tab === 'register' && !this.state.registers.length){
        notification = <div className='notification'>{tip}</div>
      }
    }
    users = users.map(user => {
      let {tel,wechat_name,addition} = user
      if(tel){
        user.tel = tel.replace(tel.substring(3,tel.length - 4),'****')
      }
      if(wechat_name){
        user.wechat_name = wechat_name.replace(wechat_name.substring(2,wechat_name.length),'**')
      }
      
      let tip = '如果我们无法探索宇宙，一定要把这颗星球看一看'
      if(addition){
        let {relation_info,referral_users,referral_number} = addition
        user.message = relation_info?relation_info.msg:tip
        user.referrals = referral_users?referral_users:[]
        user.rnumber = referral_number?referral_number:0
      }else{
        user.message = tip
        user.referrals = []
        user.rnumber = 0
      }
      return user
    })
    return (
      <div className="opportunity-memeber">
        {notification}
        {users.map((user) => {
          return (
            <div key={user._id} className="member">
              <div className="avatar-wrap">
                <img className="avatar" src={user.avatar} />
                <span className="name">{user.name} </span>
                <span className="phone">{user.wechat_name || '***'} | {user.tel || '***'}</span>
              </div>
              <div className="content">{user.message}</div>
              <div className="help">
                {user.referrals.length?(<div className="referrals">
                  <div className="title">助力用户: {user.rnumber}位</div>
                  <div className="list">
                    {user.referrals.map(referral => (<div key={referral._id} className="referral">
                      <img src={referral.avatar} />
                    </div>))}
                    {user.rnumber>5?<Link to={`/opportunity/${this.state.id}/referral?uid=${user._id}`}>更多</Link>:null}
                  </div>
                </div>):null}
                <div className="referral-link"><Link to={`/opportunity/${this.state.id}/referral?uid=${user._id}`}>为他助力</Link></div>
              </div>
              <div className="expand">小地球</div>
            </div>
          );
        })}
        {((this.state.registers.length&&this.state.tab==='register')||(this.state.selecters.length&&this.state.tab==='selecter'))?
        <Loading loading={loading} hasMore={hasMore} loadMore={this.loadMore}/>:''}
        {navigator}
        <Navigator action='home' number={2} />
        <Navigator action='left' number={3} />
      </div>
    );
  }
}

export default OpportunityMembersComponent;


// WEBPACK FOOTER //
// ./src/components/OpportunityMembersComponent.js